import type { ReservationWithDetails } from './apiHelpers';

/**
 * Address-equivalent text to show for an event reservation: the event's own
 * location when set, else its directions as a fallback, else null (hide).
 * Returns null for non-event reservations (restaurant address always shows).
 */
export function resolveEventAddressText(
  reservation: ReservationWithDetails,
): string | null {
  const event = reservation.restaurantEvent;
  if (!event) return null;
  return event.location?.trim() || event.directions?.trim() || null;
}

/**
 * Directions text to show alongside the address, only when both `location`
 * and `directions` are set (when `location` is empty, `directions` is
 * already shown as the fallback address text via resolveEventAddressText).
 */
export function resolveEventDirectionsText(
  reservation: ReservationWithDetails,
): string | null {
  const event = reservation.restaurantEvent;
  if (!event?.location?.trim() || !event.directions?.trim()) return null;
  return event.directions;
}
